import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';
import { FormControl, ReactiveFormsModule, Validators } from '@angular/forms';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { CodeEditorComponentModule } from '@selfai-platform/pipeline-shared';
import { ButtonModule } from 'primeng/button';
import { CheckboxModule } from 'primeng/checkbox';
import { InputTextModule } from 'primeng/inputtext';
import { PasswordModule } from 'primeng/password';
import { RadioButtonModule } from 'primeng/radiobutton';
import { DataSourcesCategoriesEnum } from '../../enums/data-sources-categories.enum';
import { DataSourcesAdditionsComponent } from '../data-source-additions/data-sources-additions.component';
import { DataSourceUniqueNameComponent, DataSourceVisibilityComponent } from '../data-source-form-inputs';
import { DataSourcesBasic } from '../data-sources-basic';

@Component({
  selector: 'selfai-platform-data-sources-db',
  imports: [
    CommonModule,
    ReactiveFormsModule,
    ButtonModule,
    CheckboxModule,
    InputTextModule,
    RadioButtonModule,
    PasswordModule,
    TranslateModule,
    DataSourcesAdditionsComponent,
    DataSourceUniqueNameComponent,
    DataSourceVisibilityComponent,
    CodeEditorComponentModule,
  ],
  templateUrl: './data-sources-db.component.html',
  styleUrls: ['./data-sources-db.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DataSourcesDbComponent extends DataSourcesBasic implements OnInit {
  private readonly translate = inject(TranslateService);

  readonly paramsForm = this.fb.group({
    driver: ['', Validators.required],
    url: ['', Validators.required],
    sslEnabled: [false],
    query: [''],
    table: [''],
  });

  protected readonly selectedCategory = new FormControl('');
  protected readonly dataSourcesCategoriesEnum = DataSourcesCategoriesEnum;
  protected readonly categories = [
    {
      id: this.dataSourcesCategoriesEnum.TABLE,
      labelTranslate: this.translate.instant('data-source.common.category.table'),
    },
    {
      id: this.dataSourcesCategoriesEnum.QUERY,
      labelTranslate: this.translate.instant('data-source.common.category.query'),
    },
  ];

  constructor() {
    super('jdbc');
  }

  override ngOnInit() {
    super.ngOnInit();

    const initialCategory = this.paramsForm.value.query?.length
      ? this.dataSourcesCategoriesEnum.QUERY
      : this.dataSourcesCategoriesEnum.TABLE;

    this.selectedCategory.setValue(initialCategory);
  }

  protected toggleCategoryControl(categoryId: DataSourcesCategoriesEnum): void {
    this.paramsForm.removeControl('table');
    this.paramsForm.removeControl('query');

    switch (categoryId) {
      case DataSourcesCategoriesEnum.QUERY:
        this.paramsForm.addControl('query', new FormControl('', [Validators.required]));
        this.paramsForm.addControl('table', new FormControl(''));
        break;
      case DataSourcesCategoriesEnum.TABLE:
        this.paramsForm.addControl('table', new FormControl('', [Validators.required]));
        this.paramsForm.addControl('query', new FormControl(''));
        break;
    }

    this.paramsForm.updateValueAndValidity();
  }
}
